import styled from 'styled-components'

export const Container= styled.div`
height: 100vh;
width: 411px;
margin: auto;
border-radius: 10px;
background : #EAF1F2;
/* border: 1px solid rgb(236, 229, 229); */
`
